function checkValue(fields) {
    let count = 0;
    let value = "";
    let valid = true;
    for (const field of fields) {
        field.classList.remove("error");
        field.setCustomValidity('');
        if (count === 0) {
            value = field.value;
        } else {
            if (value !== field.value) {
                valid = false;
                field.classList.add("error");
                if (GLOBALS.tc.hint_same_passwords) {
                    field.setCustomValidity(GLOBALS.tc.hint_same_passwords);
                }
            }
        }
        count++;
    }

    return valid;
}

function togglePasswordFields(wrapper) {
    wrapper.classList.toggle("is-active");
    for (const field of wrapper.querySelectorAll('input')) {
        if (wrapper.classList.contains("is-active")) {
            field.setAttribute("type", "text");
        } else {
            field.setAttribute("type", "password");
        }
    }
    for (const icon of wrapper.querySelectorAll('.passwordToggle .icon')) {
        icon.classList.toggle("icon-password-show");
        icon.classList.toggle("icon-password-hide");
    }
}

function generatePasswordToggle(field, wrapper) {
    const togglePassword = document.createElement("div");
    togglePassword.classList.add("passwordToggle");
    togglePassword.classList.add("inputGroup__addon");
    togglePassword.classList.add("inputGroup__addon--clickable");
    togglePassword.innerHTML = "<i class='icon icon-password-show'></i>";
    field.closest('.inputGroup').appendChild(togglePassword);
    field.closest('.inputGroup').classList.add('inputGroup--infieldAddon');
    togglePassword.addEventListener("click", function () {
        togglePasswordFields(wrapper);
    });
}

export function initPasswordFields(scope = document) {
    const useGeneratePasswordToggle = false;
    for (const wrapper of scope.querySelectorAll('.js-passwordFields')) {
        const fields = wrapper.querySelectorAll('input[type="password"]');
        if (fields) {
            for (const field of fields) {
                if(useGeneratePasswordToggle){
                    generatePasswordToggle(field, wrapper);
                }
                field.addEventListener("change", function () {
                    checkValue(fields);
                });
            }
        }
    }
}